/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_LC_76_67 as Componente_LC_76_67,
  rec_Componente_zC_122_67 as Componente_zC_122_67,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Cargando(e) {
  let t = (0, ReactCompiler.c)(8),
    { variante: n, cantidad: r, etiqueta: i } = e,
    a = n === void 0 ? `filas` : n,
    o = i === void 0 ? `Cargando` : i,
    s;
  t[0] === o
    ? (s = t[1])
    : ((s = <span className={`sr-only`} children={o} />),
      (t[0] = o),
      (t[1] = s));
  let c;
  t[2] !== r || t[3] !== a
    ? ((c =
        a === `tarjetas` ? (
          <Componente_zC_122_67 cantidad={r} />
        ) : (
          <Componente_LC_76_67 cantidad={r} />
        )),
      (t[2] = r),
      (t[3] = a),
      (t[4] = c))
    : (c = t[4]);
  let l;
  return (
    t[5] !== s || t[6] !== c
      ? ((l = (
          <div
            className={`animar-fundido`}
            role={`status`}
            aria-live={`polite`}
            children={[s, c]}
          />
        )),
        (t[5] = s),
        (t[6] = c),
        (t[7] = l))
      : (l = t[7]),
    l
  );
}
